export default [
  {
    path: 'page/:slug',
    name: 'page.slug',
    meta: { requiresAuth: false },
    component: () => import('@/views/gallery/PageView.vue'),
  },
]
